import React, { Fragment } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Popover, Box, Typography, makeStyles, CardHeader, Avatar, CardContent } from '@material-ui/core';
import { estados } from "../../constants/constants";
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { green,red,indigo } from '@material-ui/core/colors';
import HomeIcon from '@material-ui/icons/Home';
const useStyles=makeStyles({
    botones:{
        display:"flex",
        justifyContent:"flex-end"
    },
    box:{
        margin:"20px"
    },
    tituloCard:{
        maxWidth:"400px"
    },
    cardMargin:{
        margin:"20px"
    },
    avatar: {
        backgroundColor: indigo[500],
      },
    direcciones:{
        display: "flex",
        alignItems:"center"
    },
    MarginDirecciones:{
        marginLeft:"30px"
    }
})
const NormalDireccionesCard = ({direccion,destinatario,handleEdit,handleDelete})=> {
    // console.log(destinatario.empresa)
    const classes=useStyles();
    const estado=estados.filter((item)=> item.value===direccion.estado )
    return ( 
            <PopupState variant="popover" popupId="demo-popup-popover">
                {popupState=>(
                <div className={classes.cardMargin} >
                    <CardHeader
                    avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        {destinatario.nombre.charAt(0)}
                    </Avatar>
                    }
                    action={
                        <Fragment>
                            <IconButton onClick={handleEdit} ><EditIcon /></IconButton> 
                            <IconButton {...bindTrigger(popupState)}><Delete /></IconButton> 
                        </Fragment>
                    }
                    title={`${destinatario.nombre}`}
                    subheader={`${destinatario.correo} 
                    ${destinatario.telefono} 
                    ${destinatario.empresa}`}
                    />
                    <CardContent className={classes.direcciones}>
                        <IconButton> <HomeIcon/></IconButton>
                        <Typography className={classes.MarginDirecciones} varian="subtitle1">
              </Typography>
                      
                    </CardContent>
                   
                    
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                        }}
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                        }}
                    >
                        <Box className={classes.box} stup={2}>
                        <Typography >¿Seguro que quieres borrar esta Direccion y Destinatario?</Typography>
                        <div className={classes.botones}>
                        <IconButton onClick={handleDelete}> <CheckIcon style={{color:green[500]}} /></IconButton>
                        <IconButton onClick={popupState.close} > <CloseIcon style={{color:red[500]}}/> </IconButton>
                        </div> 
                        </Box>
                    </Popover>
                </div>
                )}
            </PopupState>
    );
}
export default NormalDireccionesCard;